import React from "react";

interface LogoAttributes {
  className?: string;
}

export const Logo: React.FC<LogoAttributes> = ({
  className = "",
}: LogoAttributes) => {
  return (
    <svg
      id="Layer_1"
      viewBox="165 170 620 620"
      className={`fill-current ${className}`}
    >
      <defs>
        <symbol id="New_Symbol_3" viewBox="0 0 711.31 771.07">
          <path
            className="cls-1"
            d="M607.14,163.93c-47.43-47.44-105.92-79.8-169.64-94.73,.97,5.19,1.77,10.37,2.37,15.52,141.92,37.25,246.62,166.4,246.62,320.01,0,89.02-35.17,169.81-92.35,229.28-8.21,8.94-16.92,17.41-26.07,25.39-94.45,69.49-188.74,26.99-197.2-51.35l-.34-38.35c19.15-.73,56.62-6.45,87.33-37.16,44.39-44.39,69.61-132.61,69.61-132.61,0,0-88.22,25.22-132.61,69.61-11.42,11.42-19.38,23.77-24.91,35.77l-1.81-202.28c17.11-18.51,46.44-58.52,46.44-115.39C414.57,105.26,356.12,0,356.12,0c0,0-58.45,105.26-58.45,187.64,0,56.66,29.12,96.6,46.26,115.19l-.97,91.08c-6.04-16.76-16.02-34.87-32.4-51.24-49.32-49.32-147.34-77.35-147.34-77.35,0,0,28.02,98.02,77.35,147.34,36.86,36.86,82.48,41.31,101.75,41.39l-1.61,151.26c-6.55,80.06-101.91,124.36-197.45,54.07-9.15-7.98-17.87-16.44-26.07-25.39-57.19-59.47-92.35-140.26-92.35-229.28,0-153.95,105.15-283.33,247.54-320.26,.61-5.12,1.42-10.3,2.4-15.49-64.09,14.84-122.92,47.29-170.59,94.96C36.99,231.1,0,320.41,0,415.41s36.99,184.31,104.17,251.49c67.17,67.17,156.49,104.17,251.49,104.17s184.31-36.99,251.48-104.17,104.17-156.49,104.17-251.49-36.99-184.31-104.17-251.49Z"
          />
        </symbol>
      </defs>
      <use
        width="711.31"
        height="771.07"
        transform="translate(196.48 173.08) scale(.78)"
        href="#New_Symbol_3"
      />
    </svg>
  );
};
